import { render } from "./SearchToolbox.vue?vue&type=template&id=20b191d4&scoped=true"
import script from "./SearchToolbox.vue?vue&type=script&lang=js"
export * from "./SearchToolbox.vue?vue&type=script&lang=js"

import "./SearchToolbox.vue?vue&type=style&index=0&id=20b191d4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-20b191d4"

export default script